import { Pipe, PipeTransform } from '@angular/core';
import { Display } from '../../../models/display/dto/display';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Pipe({
  name: 'nDisplaysSelectedInGrouping',
  standalone: false
})
export class NDisplaysSelectedInGroupingPipe implements PipeTransform {
  transform(displaysInGrouping: Display[], selectedDisplayIds$: Observable<string[]>): Observable<number> {
    return selectedDisplayIds$.pipe(
      map(selectedDisplayIds => {
        if (selectedDisplayIds) {
          return displaysInGrouping?.filter(display => selectedDisplayIds?.includes(display?.id))?.length ?? 0;
        }
        return 0;
      })
    );
  }
}
